import Deal from '../../../models/Deal';
import { FpAxios } from '@/services/FpAxios';
import processProxy from '@/env/processProxy';

class DraftDealsApi {
  private draftDealsAxios = FpAxios.create({baseURL: processProxy.VUE_APP_BASE_API_V3_URL});
  readonly baseUrl = 'drafts';

  async getDraftDeals(clientId: number, userId: number): Promise<Array<Deal>> {
    const response = await this.draftDealsAxios.get<{draftDeals: Array<Deal>}>(`drafts/basket/client/${clientId}/user/${userId}`);
    return response.data.draftDeals;
  }

  async deleteDraftDeal(draftId: number | string): Promise<void> {
    await this.draftDealsAxios.delete(`drafts/basket/draft/${draftId}`);
  }

}

export default new DraftDealsApi();
